<div class="navWrap">
  <div class="left">
    <a [routerLink]="['./home']">
      <img id="logo" src="assets/images/logo.svg" />
    </a>
  </div>

  <div class="middle" *ngIf="showNavigationButtons">
    <button mat-icon-button class="mat-primary" disabled>
      <mat-icon svgIcon="as_jump" [matTooltip]="'navigation_jump' | phrase" matTooltipPosition="below"></mat-icon>
    </button>
    <button mat-icon-button class="mat-primary" [disabled]="!canUndo" (click)="undo()">
      <mat-icon svgIcon="as_back" [matTooltip]="'navigation_undo' | phrase" matTooltipPosition="below"></mat-icon>
    </button>
    <button mat-icon-button class="mat-primary mirrored" [disabled]="!canRedo" (click)="redo()">
      <mat-icon svgIcon="as_back" [matTooltip]="'navigation_redo' | phrase" matTooltipPosition="below"></mat-icon>
    </button>
    <button mat-icon-button class="mat-primary" (click)="addQuickWord()" [disabled]="true">
      <mat-icon svgIcon="as_a_plus_time" [matTooltip]="'navigation_quick_word' | phrase" matTooltipPosition="below"> </mat-icon>
    </button>
    <button mat-icon-button class="mat-primary" (click)="onEditorClearClick()" [disabled]="saving">
      <mat-icon svgIcon="as_a_plus" [matTooltip]="'navigation_new' | phrase" matTooltipPosition="below"></mat-icon>
    </button>
    <button mat-icon-button class="mat-primary" [disabled]="!canDelete" (click)="ondeleteClick()">
      <mat-icon svgIcon="as_delete" [matTooltip]="'navigation_delete' | phrase" matTooltipPosition="below"></mat-icon>
    </button>
    <button mat-icon-button class="mat-primary" [disabled]="!prevFjalaId || saving" (click)="onPrevClick()">
      <mat-icon svgIcon="as_cancel_and_back" [matTooltip]="'navigation_back' | phrase" matTooltipPosition="below"> </mat-icon>
    </button>
    <button mat-icon-button class="mat-primary" [disabled]="!formDirty || !formValid || !prevFjalaId || saving" (click)="onSaveBackClick()">
      <mat-icon svgIcon="as_save_and_back" [matTooltip]="'navigation_save_and_back' | phrase" matTooltipPosition="below"></mat-icon>
    </button>
    <button mat-icon-button class="mat-primary" [disabled]="!formDirty || !formValid">
      <mat-icon svgIcon="as_save" [matTooltip]="'navigation_save' | phrase" matTooltipPosition="below" (click)="saveWord()"></mat-icon>
    </button>
    <button mat-icon-button class="mat-primary" [disabled]="!formDirty || !formValid || !nextFjalaId || saving" (click)="onSaveNextClick()">
      <mat-icon svgIcon="as_save_and_next" [matTooltip]="'navigation_save_and_next' | phrase" matTooltipPosition="below"></mat-icon>
    </button>
    <button mat-icon-button class="mat-primary" [disabled]="!nextFjalaId || saving" (click)="onNextClick()">
      <mat-icon svgIcon="as_cancel_and_next" [matTooltip]="'navigation_next' | phrase" matTooltipPosition="below"> </mat-icon>
    </button>
    <button mat-icon-button class="mat-primary" (click)="openShenimet()">
      <mat-icon svgIcon="as_notes" [matTooltip]="'navigation_notes' | phrase" matTooltipPosition="below"></mat-icon>
    </button>
    <button mat-icon-button class="mat-primary" [disabled]="!canDelete" (click)="onCommentsClick()">
      <mat-icon svgIcon="as_comments" [matTooltip]="'navigation_comments' | phrase" matTooltipPosition="below"> </mat-icon>
    </button>
    <button mat-icon-button class="mat-primary" disabled>
      <mat-icon svgIcon="as_history" [matTooltip]="'navigation_history' | phrase" matTooltipPosition="below"></mat-icon>
    </button>
  </div>

  <div class="right">
    <app-perdoruesit></app-perdoruesit>
    <button (click)="toggleTheme()" type="button" mat-icon-button>
      <mat-icon class="light-icon" *ngIf="darkMode">light_mode</mat-icon>
      <mat-icon class="dark-icon" *ngIf="!darkMode">dark_mode</mat-icon>
    </button>
    <button mat-icon-button class="mat-primary" [routerLink]="['./blog']" disabled>
      <mat-icon svgIcon="as_blog" [matTooltip]="'navigation_blog' | phrase" matTooltipPosition="below"></mat-icon>
    </button>
    <button mat-icon-button class="mat-primary" [matMenuTriggerFor]="settings">
      <mat-icon svgIcon="as_settings"></mat-icon>
    </button>
    <mat-menu #settings="matMenu" xPosition="before" class="drop-down-menu">
      <ng-container *hasRoles="['admin']">
        <button mat-menu-item [routerLink]="['./admin']">
          {{ 'settings_menu_admin' | phrase }}
        </button>
      </ng-container>
      <button mat-menu-item [routerLink]="['./contributions']">
        {{ 'settings_menu_contributions' | phrase }}
      </button>
      <button mat-menu-item (click)="logout()">
        {{ 'settings_menu_logoff' | phrase }}
      </button>
    </mat-menu>
  </div>
  <mat-progress-bar [mode]="loading ? 'query' : 'indeterminate'" *ngIf="saving || loading"></mat-progress-bar>
</div>
